<script setup lang="ts">
import type { Schemas } from "#shopware";
const {
  appliedPromotionCodes,
  addPromotionCode,
  removeItem,
  consumeCartErrors,
} = useCart();
const { t } = useI18n();

const toast = useToast();

const addPromotionCodeHandler = async (code: string) => {
  await addPromotionCode(code);
  Object.entries(consumeCartErrors())?.forEach(([key, value]) => {
    if (value.messageKey === "promotion-discount-added") {
      return;
    }

    toast.add({
      severity: "error",
      detail: t(`errors.${value.messageKey}`, { ...value }),
      life: 3000,
    });
  });
  promoCode.value = "";
};

const removeItemHandler = async (appliedPromotionCode: Schemas["LineItem"]) => {
  await removeItem(appliedPromotionCode);
  consumeCartErrors() &&
    Object.entries(consumeCartErrors())?.forEach(([key, value]) => {
      toast.add({
        severity: "error",
        detail: t(`errors.${value.messageKey}`, { ...value }),
        life: 3000,
      });
    });
};

const showPromotionCodes = computed(
  () => appliedPromotionCodes.value.length > 0,
);

const promoCode = ref("");
</script>

<template>
  <div>
    <div class="mb-4">
      <form
        @submit.prevent="addPromotionCodeHandler(promoCode)"
        class="flex gap-3"
      >
        <InputText
          v-model="promoCode"
          required
          type="text"
          name="promoCode"
          class="w-full"
          :placeholder="$t('form.promoCodePlaceholder')"
        />
        <Button size="small" type="submit">{{ $t("product.add") }}</Button>
      </form>
    </div>

    <div v-if="showPromotionCodes">
      <span class="text-xs">{{ $t("checkout.promoCode.label") }}:</span>

      <div class="text-sm space-y-2 mt-2">
        <InlineMessage
          v-for="appliedPromotionCode in appliedPromotionCodes"
          :key="appliedPromotionCode.id"
          severity="success"
          class="w-full"
          :pt="{ text: 'w-full' }"
        >
          <template #icon>&hairsp;</template>
          <div class="flex gap-2 justify-between w-full">
            <span>{{ appliedPromotionCode.label }}</span>
            <button
              class="pi pi-times hover:scale-110 transition"
              @click="removeItemHandler(appliedPromotionCode)"
            ></button>
          </div>
        </InlineMessage>
      </div>
    </div>
  </div>
</template>
